export default __webpack_public_path__ + "static/media/ath-filled.cd216f3c.png";